import { render, staticRenderFns } from "./ContractSelectedSupplierModule.vue?vue&type=template&id=5e2fb23d&scoped=true&lang=pug&"
import script from "./ContractSelectedSupplierModule.vue?vue&type=script&lang=ts&"
export * from "./ContractSelectedSupplierModule.vue?vue&type=script&lang=ts&"
import style0 from "./ContractSelectedSupplierModule.vue?vue&type=style&index=0&id=5e2fb23d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2fb23d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VTextField,VTextarea})
